class Menu{

    constructor(){
        this.menuToggle = document.querySelectorAll('.menuToggle');

        this.onclick();
    }

    /**
     *
     */
    onclick(){
        Array.from(this.menuToggle).map(
            (element) => {
                element.addEventListener('click', function(){
                    document.querySelector('body').classList.toggle('MenuIsOpen');
                })
            }
        );
    }

}

new Menu();
